<template>
  <!-- CONTENT -->
  <vx-card>
    <div class="content-container">
      <!-- HEAD -->
      <div class="flex items-center justify-start gap-2 mb-3">
        <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
          <vs-select-item v-for="_perPage in perPageOpstions" :key="`perpage_${_perPage}`" :text="`${_perPage}개씩 보기`" :value="_perPage" />
        </vs-select>
        <filter-module
          :filter-keys="['시설구분', '보관자', '관리방법', '소관부서', '담당주무관']"
          :filter-types="['multi-select', 'input', 'multi-select', 'input', 'input']"
          :filter-value-options="{
          '시설구분': this.filterCodeName,
          '관리방법': ['직접관리', '위탁관리'],
        }"
          :value="nav.filter"
          @input="filterButtonInput">
        </filter-module>
        <SearchNavItemKeyword :viewLabel="true" label="" v-model="nav.searchKeyword" class="ml-auto" @keyupEvent="handleKeywordSearch" />
      </div>
      <h5 class="pt-2 pb-4">대상수 : {{ tableData.length }}개소</h5>

      <!-- TABLE -->
      <table>
        <colgroup>
          <col width="100" />
          <col/>
          <col/>
          <col/>
        </colgroup>
        <thead>
        <tr>
          <th>연번</th>
          <th>소관부서</th>
          <th>담당자</th>
          <th>시설구분</th>
          <th>시설명</th>
          <th>시설위치(사업장주소)</th>
          <th>면적(㎡), 형식, 연장,<br/>차로수, 높이 등</th>
          <!-- <th>적용제외대상</th> -->
          <th>비고</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, row_i) in renderTableData" :key="row_i" @click="handleRowClick(row)" class="cursor-pointer">
          <td>{{ (nav.currentPage - 1) * nav.perPage + row_i + 1 }}</td>
          <td>{{ row.소관부서 }}</td>
          <td>{{ row.담당주무관 }}</td>
          <td>{{ row.시설구분 }}</td>
          <td>{{ row.시설물명 }}</td>
          <td>{{ row.주소 }}</td>
          <td>{{ row.면적형식연장등 }}</td>
          <!-- <td>{{ row.적용제외대상 }}</td> -->
          <td>{{ row.비고 }}</td>
        </tr>
        <tr v-if="renderTableData.length === 0">
          <td :colspan="nav.currentTab === 'all' ? 5 : 4">표시할 데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>

      <!-- PAGINATION -->
      <div class="vs-con-table mt-10">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="nav.total" :perPage="nav.perPage" :max-items="5" v-model="nav.currentPage"></k-pagination>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";
import FilterModule from "./FilterModule.vue";

export default {
  components: {
    FilterModule,
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    KPagination,
  },
  data() {
    return {
      nav: {
        currentTab: "all",

        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{key: '시설구분', value: ['전체']}],

        perPage: 50,
        currentPage: 1,
        total: 0,
      },
      apiData: [], // api 호출로 받아온 데이터
      tableData: [], // 필터 적용 후 데이터
      renderTableData: [], // 페이징처리되어 화면에 표기될 데이터
      cacheData: null, // 캐시된 데이터
      cacheExpiry: null, // 캐시 만료 시간
      cacheDuration: 60 * 60 * 1000, // 1시간 (밀리초)
      공중이용시설Codes: {
        '도서관': 'library',
        '박물관 및 미술관': 'museum',
        '의료기관': 'medical',
        '어린이집': 'daycare',
        '업무시설': 'office',
        '실내공연장': 'indoor-auditorium',
        '둘이상용도건축물': 'mixed-use-building',
        '건축물': 'building',
        '항만(방파제)': 'port',
        '항만(부두)': 'port-dock',
        '교량': 'bridge',
        '터널': 'tunnel',
        '옹벽': 'retaining-wall',
        '절토사면': 'cutting-slope',
        '제방': 'dike',
        '소규모수도': 'waterworks',
        '청사': 'government-building',
        '복합시설': 'complex-facility',
        '하수도': 'sewage-treatment',
        '상수도': 'water-supply',
        '실내체육시설': 'indoor-sports-facility',
      },
      원료제조물Codes: {
        '급식소': 'mass_feeding_facility',
        '먹는물': 'drinking-water',
        '승강기': 'lift',
        '식품제조가공업': 'food-processing',
        '어린이 놀이시설': 'kids-play-area',
      }
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    perPageOpstions() {
      return [10, 20, 50, 75, 100, 125, 150];
    },
    filterCodeName () {
      return Object.keys(this.codes);
    },
    searchFieldCodes() {
      const codes = this.codes;
      if (this.nav.filter.length === 0) {
        return Object.values(codes);
      }

      const selectCodes = []
      if (this.nav.filter.length > 0) {
        for (const filter of this.nav.filter) {
          if (filter.key === "시설구분") {
            if (filter.value.includes('전체')) {
              for (const key in codes) {
                if (!selectCodes.includes(codes[key])) {
                  selectCodes.push(codes[key]);
                }
              }
            } else if (filter.value.length > 0) {
              for (const value of filter.value) {
                if (codes[value] && !selectCodes.includes(codes[value])) {
                  selectCodes.push(codes[value]);
                }
              }
            }
          } else {
            for (const key in codes) {
              if (!selectCodes.includes(codes[key])) {
                selectCodes.push(codes[key]);
              }
            }
          }
        }
      }
      return selectCodes
    },
    codes() {
      const codes = {
        ...this.공중이용시설Codes,
        ...this.원료제조물Codes,
      };
      return codes;
    }
  },
  watch: {
    "nav.searchKeyword"() {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setTableData();
    },
    "nav.perPage"() {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.currentPage"() {
      this.setRenderTableData();
    },
    "nav.searchYear"() {
      this.$set(this.nav, "currentPage", 1);
      this.loadAPI();
    },
  },
  created() {
    this.loadAPI();
  },
  beforeDestroy() {
    // 메모리 정리 (로컬 스토리지 캐시는 유지)
    this.cacheData = null;
    this.cacheExpiry = null;
  },
  methods: {
    // 검색 버튼 클릭
    handleClickSearch() {
      this.setTableData();
    },
    // 키워드 검색 처리
    handleKeywordSearch() {
      this.nav.currentPage = 1;
      this.setTableData();
    },
    // 캐시 강제 새로고침
    async refreshData() {
      this.clearCache();
      await this.loadAPI();
    },
    filterButtonInput(data) {
      this.nav.filter = data;
      this.nav.currentPage = 1;
      this.setTableData();
    },
    // 탭 이동
    moveTab(data) {
      this.nav.currentTab = data;
    },

    // 캐시 키 생성
    generateCacheKey(latestUpdatedAt, totalCount) {
      return `field_list_${this.projectId}_${latestUpdatedAt}_${totalCount}`;
    },

    // 캐시에 데이터 저장
    setCacheData(data, cacheKey) {
      this.cacheData = data;
      this.cacheExpiry = Date.now() + this.cacheDuration;

      // 로컬 스토리지에도 저장
      const cacheInfo = {
        data,
        expiry: this.cacheExpiry,
        key: cacheKey
      };
      localStorage.setItem(`maot_cache_${this.projectId}`, JSON.stringify(cacheInfo));
    },

    // 캐시 초기화
    clearCache() {
      this.cacheData = null;
      this.cacheExpiry = null;
      localStorage.removeItem(`maot_cache_${this.projectId}`);
    },

    // 로컬 스토리지에서 캐시 복원
    restoreCacheFromStorage() {
      try {
        const cached = localStorage.getItem(`maot_cache_${this.projectId}`);
        if (cached) {
          const cacheInfo = JSON.parse(cached);
          if (Date.now() < cacheInfo.expiry) {
            this.cacheData = cacheInfo.data;
            this.cacheExpiry = cacheInfo.expiry;
            return true;
          } else {
            localStorage.removeItem(`maot_cache_${this.projectId}`);
          }
        }
      } catch (error) {
        console.error('캐시 복원 중 오류:', error);
        localStorage.removeItem(`maot_cache_${this.projectId}`);
      }
      return false;
    },

    // 최신 데이터 정보 조회 (캐시 검증용)
    async getLatestDataInfo() {
      const params = {
        page: 1,
        perPage: 1,
        projectId: this.projectId,
        order_by: 'updated_at',
        order_direction: 'desc'
      };

      try {
        const response = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
        const latestData = response.data && response.data[0] ? response.data[0] : null;
        return {
          latestUpdatedAt: latestData && latestData.updated_at ? latestData.updated_at : '',
          totalCount: response.total ? response.total : 0
        };
      } catch (error) {
        console.error('최신 데이터 정보 조회 실패:', error);
        return { latestUpdatedAt: '', totalCount: 0 };
      }
    },

    // 모든 데이터 불러오기
    async _loadAPI(page, list) {
      const params = {
        page,
        perPage: 50,
        projectId: this.projectId,
      };
      const _apiData = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
      list.push(..._apiData.data);
      if (_apiData && Number(_apiData.last_page) >= Number(page)) {
        await this._loadAPI(page + 1, list);
      }
    },

    async loadAPI() {
      this.$vs.loading();

      try {
        // 1. 최신 데이터 정보 먼저 조회 (캐시 키 생성용)
        // console.log('최신 데이터 정보 조회 중...');
        const { latestUpdatedAt, totalCount } = await this.getLatestDataInfo();
        console.log('최신 데이터 정보:', { latestUpdatedAt, totalCount });
        const currentCacheKey = this.generateCacheKey(latestUpdatedAt, totalCount);
        // console.log('현재 캐시 키:', currentCacheKey);

        // 2. 로컬 스토리지에서 캐시 확인 (키 검증 포함)
        const existingCache = localStorage.getItem(`maot_cache_${this.projectId}`);
        if (existingCache) {
          try {
            const cacheInfo = JSON.parse(existingCache);
            // console.log('저장된 캐시 키:', cacheInfo.key);
            // console.log('키 일치 여부:', cacheInfo.key === currentCacheKey);
            // console.log('캐시 만료 여부:', Date.now() > cacheInfo.expiry);

            if (cacheInfo.key === currentCacheKey && Date.now() < cacheInfo.expiry) {
              // console.log('유효한 캐시 데이터 사용');
              this.cacheData = cacheInfo.data;
              this.cacheExpiry = cacheInfo.expiry;
              this.apiData = this.cacheData;
              this.setTableData();
              this.$vs.loading.close();
              return;
            } else {
              // console.log('캐시 무효 - 새로운 데이터 로드 필요');
              this.clearCache();
            }
          } catch (error) {
            console.error('캐시 정보 파싱 오류:', error);
            this.clearCache();
          }
        } else {
          // console.log('로컬 스토리지에 캐시 없음');
        }

        // 3. 새로운 데이터 로드
        // console.log('새로운 데이터 로드');
        const data = [];
        await this._loadAPI(1, data);

        // 4. 캐시에 저장
        this.setCacheData(data, currentCacheKey);
        this.apiData = data;
        this.setTableData();

      } catch (error) {
        console.error('데이터 로드 중 오류:', error);
        this.$vs.notify({
          title: '오류',
          text: '데이터를 불러오는 중 오류가 발생했습니다.',
          color: 'danger'
        });
        this.setTableData();
      } finally {
        // console.log('로딩 종료');
        this.$vs.loading.close();
      }
    },
    setTableData() {
      this.tableData = [];

      const _filterData = this.apiData.filter((data) => {
        const meta = JSON.parse(data.meta);

        // codes
        if (!this.searchFieldCodes.includes(data.field_type)) return false;

        // 키워드 검색 필터링
        if (this.nav.searchKeyword && this.nav.searchKeyword.trim()) {
          const keyword = this.nav.searchKeyword.trim().toLowerCase();
          const searchFields = [
            data.field_name || '', // 시설물명
            data.address || '', // 주소
            meta.소관부서 || '', // 소관부서
            meta.담당주무관 || '', // 담당주무관
            this.getFieldTypeToString(data.field_type) || '', // 시설구분
            meta.비고 || '' // 비고
          ];

          const hasKeyword = searchFields.some(field => field.toLowerCase().includes(keyword)
          );

          if (!hasKeyword) return false;
        }

        for (let i = 0; i<this.nav.filter.length; i++) {
          const filter = this.nav.filter[i];

          if (filter.key === '보관자') {
            if ((filter.value && !meta.보관자) || meta.보관자.indexOf(filter.value) < 0) return false;
          } else if (filter.key === '관리방법') {
            if (filter.value.includes('전체')) {
              // 전체인 경우 필터링하지 않음
            } else if (!filter.value.includes(meta.관리방법)) return false;
          } else if (filter.key === '소관부서') {
            if ((filter.value && !meta.소관부서) || meta.소관부서.indexOf(filter.value) < 0) return false;
          } else if (filter.key === '담당주무관') {
            if ((filter.value && !meta.담당주무관) || meta.담당주무관.indexOf(filter.value) < 0) return false;
          }
        }

        return true;
      })

      const _시설분류 = (data) => {
        const 공중이용시설Values = Object.values(this.공중이용시설Codes);
        const 원료제조물Values = Object.values(this.원료제조물Codes);

        if (공중이용시설Values.includes(data.field_type)) {
          return '공중이용시설'
        } else if (원료제조물Values.includes(data.field_type)) {
          return '원료제조물'
        } else {
          return '기타'
        }
      }

      const _시설구분 = (data, 종별) => {
        // 필드 타입을 시설종류(한글)로 변환
        const fieldType = data.field_type;
        const fieldTypeName = this.getFieldTypeToString(fieldType);

        // 시설종류에 따른 분기 처리
        switch (fieldTypeName) {
        case '건축물':
          return '32-건축물';

        case '교량':
          if (data && data.facility_category) {
            const classification = data.facility_category.classification || '';
            // 도로교량
            if (data.facility_category.cat2.includes('도로교량')) {
              if (classification === '1종') return '25-1종 교량';
              if (classification === '2종') return '25-2종 교량';
              if (classification === '3종') return '98-3종 교량';
              // 철도교량
            } else if (data.facility_category.cat2.includes('철도')) {
              if (classification === '1종') return '26-1종 교량';
              if (classification === '2종') return '26-2종 교량';
              if (classification === '3종') return '100-3종 교량';
            }
          }
          return '교량';

        case '도서관':
          return '7-도서관';

        case '둘이상용도건축물':
          return '17-둘이상용도건축물';

        case '박물관 및 미술관':
          return '8-박물관 및 미술관';

        case '복합시설':
          return '17-복합시설';

        case '상수도':
          return '36-상수도';

        case '수도':
        case '소규모수도':
          return '89-수도법';

        case '실내체육시설':
          return '19-실내 체육시설';

        case '실내공연장':
          return '18-실내 공연장';

        case '어린이집':
          return '11-어린이 집';

        case '업무시설':
          return '16-업무시설';

        case '옹벽':
          if (종별 === '1종') return '38-1종 옹벽';
          if (종별 === '2종') return '38-2종 옹벽';
          if (종별 === '3종') return '38-3종 옹벽';
          return '38-옹벽';

        case '의료기관':
          return '9-의료기관';

        case '절토사면':
          if (종별 === '1종') return '38-1종 절토사면';
          if (종별 === '2종') return '38-2종 절토사면';
          if (종별 === '3종') return '38-3종 절토사면';
          return '38-절토사면';

        case '제방':
          return '34-제방';

        case '청사':
          return '16-청사';

        case '터널':
          if (data && data.facility_category) {
            const classification = data.facility_category.classification || '';
            // 도로터널
            if (data.facility_category.cat2.includes('도로')) {
              if (classification === '1종') return '27-1종 터널';
              if (classification === '2종') return '27-2종 터널';
              if (classification === '3종') return '99-3종 터널';
              // 철도터널
            } else if (data.facility_category.cat2.includes('철도')) {
              if (classification === '1종') return '28-1종 터널';
              if (classification === '2종') return '28-2종 터널';
              if (classification === '3종') return '101-3종 터널';
            }
          }
          return '터널';

        case '하수도':
          return '37-하수도';

        case '항만(방파제)':
          return '29-방파제';

        case '항만(부두)':
          return '30-부두';

        case '급식소':
          return '69-식품, 식품첨가물, 기구 및 용기포장(집단급식소)';

        case '먹는물':
          return '90-먹는물 관리법';

        case '승강기':
          return '85-승강기 안전관리법';

        case '식품제조가공업':
          return '69-식품제조가공업';

        case '어린이 놀이시설':
          return '84-어린이 놀이시설 안전관리법';

        default:
          return `${fieldTypeName} - ${종별}`;
        }
      }

      const _면적형식연장등 = (data) => {
        const meta = JSON.parse(data.meta);
        const 건축_연면적 = meta.건축_연면적;
        const 층수_최고높이 = meta.층수_최고높이;
        const 연장_길이 = meta.연장_길이;

        // 교량, 터널
        const 차로수_상행 = meta.차로수_상행;
        const 차로수_하행 = meta.차로수_하행;

        // 교량
        const 경간형식 = meta.경간형식;

        // 상수도, 먹는물
        const 시설용량 = meta.시설용량;

        // 옹벽, 절토사면, 터널, 항만(부두)
        const 연장 = meta.연장;
        const 높이 = meta.높이;

        // 제방
        const 제방연장 = meta.제방연장;

        // 터널
        const 주요공법 = meta.주요공법;

        // 하수도
        const 일평균 = meta.일평균;

        // 항만(방파제)
        const 종류 = meta.종류;
        const 허용월파량_호안 = meta.허용월파량_호안;

        // 항만(부두)
        const 대표형식 = meta.대표형식;

        // 급식소
        const 일평균_식수인원 = meta.일평균_식수인원;


        const 기타_상세제원 = meta.기타_상세제원 || meta.otherSpecifications;

        let result = '';
        if (건축_연면적) result += `건축 연면적: ${건축_연면적}, `;
        if (층수_최고높이) result += `층수-최고높이: ${층수_최고높이}, `;
        if (연장_길이) result += `연장-길이: ${연장_길이}, `;
        if (차로수_상행) result += `차로수-상행: ${차로수_상행}, `;
        if (차로수_하행) result += `차로수-하행: ${차로수_하행}, `;
        if (시설용량) result += `시설용량: ${시설용량}, `;
        if (경간형식) result += `경간형식: ${경간형식}, `;
        if (연장) result += `연장: ${연장}, `;
        if (높이) result += `높이: ${높이}, `;
        if (주요공법) result += `주요공법: ${주요공법}, `;
        if (일평균) result += `일평균: ${일평균}, `;
        if (제방연장) result += `제방연장: ${제방연장}, `;
        if (종류) result += `종류: ${종류}, `;
        if (허용월파량_호안) result += `허용월파량(호안): ${허용월파량_호안}, `;
        if (대표형식) result += `대표형식: ${대표형식}, `;
        if (일평균_식수인원) result += `일평균 식수인원: ${일평균_식수인원}, `;
        if (기타_상세제원) result += `기타 상세제원: ${기타_상세제원}, `;
        result = result.slice(0, -2);

        if (result.length === 0) return '-';
        return result;
      }

      // 테이블 형식에 맞게 apiData 변형
      const _tableData = _filterData.map((data) => {
        const meta = JSON.parse(data.meta);
        const 종별 = (data.facility_category && data.facility_category.classification) || '기타';
        const _data = {
          분류: _시설분류(data),
          시설구분: _시설구분(data, 종별),
          시설물명: data.field_name,
          주소: data.address || '-',
          면적형식연장등: _면적형식연장등(data),
          적용제외대상: meta.적용제외대상 || '-',
          비고: meta.remarks || '-',
          보관자: meta.보관자,
          관리방법: meta.관리방법,
          소관부서: meta.소관부서,
          담당주무관: meta.담당주무관,
          field_type: data.field_type ? data.field_type : '',
          id: data.id,
        }
        return _data;
      });

      this.tableData = _tableData.sort((a, b) => {

        // 소관부서 아래 순서로 1차 정렬
        const 소관부서 = [
          "기획예산담당관", "우주항공과", "투자유치산단과", "지역경제과", "관광정책과",
          "문화예술과", "체육진흥과", "행정과", "회계과", "노인장애인과",
          "여성가족과", "환경보호과", "도로과", "녹지공원과", "건설과",
          "도시재생과", "치매관리과", "농축산과", "미래농업과", "평생학습센터",
          "상하수도사업소", "사천읍", "정동면", "용현면", "서포면",
          "동서동", "동서금동", "벌용동", "남양동"
        ];
        if (소관부서.indexOf(a.소관부서) < 소관부서.indexOf(b.소관부서)) return -1;
        if (소관부서.indexOf(a.소관부서) > 소관부서.indexOf(b.소관부서)) return 1;

        // 분류 아래 순서로 2차 정렬
        const 분류 = ['공중이용시설', '원료제조물', '기타'];
        if (분류.indexOf(a.분류) < 분류.indexOf(b.분류)) return -1;
        if (분류.indexOf(a.분류) > 분류.indexOf(b.분류)) return 1;

        // 시설구분 오름차순으로 3차 분류
        if (a.시설구분 < b.시설구분) return -1;
        if (a.시설구분 > b.시설구분) return 1;

        // 시설물명 오름차순으로 4차 분류
        if (a.시설물명 < b.시설물명) return -1;
        if (a.시설물명 > b.시설물명) return 1;

        return 0;
      });
      this.setRenderTableData();
    },
    setRenderTableData() {
      const datas = this.tableData;

      const _total = Math.ceil(datas.length / this.nav.perPage);
      this.nav.total = _total < 1 ? 1 : _total;

      const perPage = this.nav.perPage;
      const currentPage = this.nav.currentPage;

      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;

      this.renderTableData = datas.slice(start, end);
    },
    getFieldTypeToString(type) {
      const keys = Object.keys(this.codes);
      for (const key of keys) {
        if (this.codes[key] === type) return key;
      }
    },
    handleRowClick(row) {
      const fieldDataList = this.apiData.filter(data => data.field_name === row.시설물명);
      if (fieldDataList.length > 0) {
        const fieldType = row.field_type
        const fieldId = row.id;
        if (!fieldType || !fieldId) return;

        // 페이지 이동
        this.$router.push(`/project/${this.projectId}/field/${fieldType}/write/${fieldId}`);
      } else {
        console.warn('해당 시설물 데이터를 찾을 수 없습니다.');
      }

    }
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
    padding: 18px 0;
  }

  tbody tr {
    cursor: pointer;

    &:hover {
      background-color: #f0f0f0;
    }
  }
}
</style>
